import React from 'react';

import { Button, Pagination, Tooltip } from '@attentive-platform/stem-ui';

import { companiesLabel, estimatorName } from './api';
import { PaginationRow } from './styles';

const EstimatorActions = ({ estimator, busy, locked, onCompanies, onToggleActive }) => {
  const handleCompanies = () => onCompanies(estimator);
  const handleToggle = () => onToggleActive(estimator);

  return (
    <div className='flex items-center gap-1'>
      <Button size='medium' variant='text' color='primary' disabled={busy} onClick={handleCompanies}>
        Companies
      </Button>
      <Button
        size='medium'
        variant='text'
        color={estimator.isActive ? 'error' : 'primary'}
        loading={busy}
        disabled={locked}
        onClick={handleToggle}>
        {estimator.isActive ? 'Disable' : 'Enable'}
      </Button>
    </div>
  );
};

const EstimatorsTable = ({
  estimators,
  loading,
  updatingId,
  page,
  pageCount,
  onPageChange,
  onCompanies,
  onToggleActive
}) => {
  return (
    <>
      <table className='w-full border-collapse text-left text-sm'>
        <thead>
          <tr className='bg-gray-100 text-gray-900'>
            <th className='px-6 py-3 font-semibold'>Name</th>
            <th className='px-6 py-3 font-semibold'>Companies</th>
            <th className='px-6 py-3 font-semibold'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td className='px-6 py-6 text-gray-500' colSpan={3}>
                Loading accounts…
              </td>
            </tr>
          )}
          {!loading && estimators.length === 0 && (
            <tr>
              <td className='px-6 py-6 text-gray-500' colSpan={3}>
                No accounts found
              </td>
            </tr>
          )}
          {!loading &&
            estimators.map((estimator, index) => {
              const name = estimator.fullName || estimatorName(estimator.raw);
              const companies = estimator.companies || [];
              const companyText = companiesLabel(companies);
              const busy = updatingId === estimator.id;
              const locked = Boolean(updatingId);
              return (
                <tr key={`${estimator.id || 'row'}-${estimator.email}-${index}`} className='border-t border-gray-200'>
                  <td className='px-6 py-4 align-top'>
                    <div className='flex items-center gap-2'>
                      <span className='font-semibold text-gray-900'>{name}</span>
                      {!estimator.isActive && (
                        <span className='inline-flex items-center rounded-md bg-gray-200 px-1.5 py-0.5 text-xs font-medium text-gray-500'>
                          Disabled
                        </span>
                      )}
                    </div>
                    <div className='mt-0.5 text-xs text-gray-500'>{estimator.email || '—'}</div>
                  </td>
                  <td className='px-6 py-4 align-top text-gray-800'>
                    {companies.length > 0 ? (
                      <Tooltip
                        arrow
                        placement='top'
                        variant='dark'
                        title={
                          <div>
                            {companies.map(company => (
                              <div key={company.id}>{company.name}</div>
                            ))}
                          </div>
                        }>
                        <span>{companyText}</span>
                      </Tooltip>
                    ) : (
                      companyText
                    )}
                  </td>
                  <td className='px-6 py-4 align-top'>
                    <EstimatorActions
                      estimator={estimator}
                      busy={busy}
                      locked={locked}
                      onCompanies={onCompanies}
                      onToggleActive={onToggleActive}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      {pageCount > 1 && (
        <PaginationRow>
          <Pagination
            size='small'
            color='primary'
            count={pageCount}
            page={page}
            disabled={loading}
            onChange={onPageChange}
          />
        </PaginationRow>
      )}
    </>
  );
};

export default EstimatorsTable;
